// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 8: MSAADA WA ALIYE JUU SANA (BONUS)
// ============================================================================
// Kiwango 92 (kiwango 1 cha bonasi, maswali 3)

export const chapter8Translations = {
  name: "Msaada wa Aliye Juu Sana",
  description: "Yeye akaaye katika sitara ya Aliye Juu Sana atakaa chini ya kivuli cha Mwenyezi",
  
  spiritualWisdom: {
    principle: "Umefika kilele cha mlima, na maarifa yamepatiwa",
    scripture: "Yeye akaaye katika sitara ya Aliye Juu Sana atakaa chini ya kivuli cha Mwenyezi (Zaburi 91:1)",
    application: "Imani isiyotikisika inahitaji uzoefu wa maisha, rehema na upendo wa kweli wa Yesu. Majaribu yatajaribu moyo wako, njia ya kweli uliyochagua."
  },
  
  levels: {
    92: {
      name: "Sitara ya Aliye Juu Sana",
      challenge: "Uko kilele cha mlima... Lakini imani isiyotikisika inaanza sasa...",
      easy: {
        question: "Yesu ni nani kwako binafsi?",
        options: [
          "Nabii wa kawaida",
          "Bwana wangu na Mwokozi wangu binafsi",
          "Hadithi",
          "Falsafa"
        ],
        hint: "Yeye ndiye anayetoa maisha yake kutuokoa",
        funFact: "✝️ Yesu ni Mungu! Yeye si tu mtu wa kihistoria - Yu hai na anataka mahusiano ya kibinafsi na kila mmoja wetu!"
      },
      medium: {
        question: "Kwa nini kufunga kama Danieli kunatuwezesha kusikia Mungu vizuri zaidi?",
        options: [
          "Kupunguza uzito",
          "Kujinyima tunachopenda na kuwa na moyo uliobadilishwa",
          "Kuwavutia wengine",
          "Kuwa na nguvu zaidi"
        ],
        hint: "Jinyime unachokipenda zaidi, katika utulivu na hekima",
        funFact: "🙏 Kufunga kwa kiroho kunaandaa mioyo yetu kwa mabadiliko makubwa - mara nyingi ya uchungu - yanayotukaribia Mungu!"
      },
      hard: {
        question: "Ni jibu gani la kweli la moyo mbele ya maarifa haya yote yaliyopatikana?",
        options: [
          "Sasa ni mkamilifu",
          "Nakupa moyo wangu Yesu na nataka kubatizwa",
          "Najua vizuri kuliko wengine",
          "Sihitaji msaada tena"
        ],
        hint: "Imani ya kweli inasababisha kujisalimisha kabisa na kujitolea kwa Yesu",
        funFact: "🌟✨ Umefika kilele cha mlima, na maarifa yamepatiwa ✨\n\n💖 Imani isiyotikisika inahitaji uzoefu wa maisha, rehema na upendo wa kweli wa Yesu 💖\n\n🔥 Majaribu mbalimbali ya maisha yatajaribu njia yako, njia ya kweli tunayochagua, mioyo yetu 🔥\n\n😔 Tunabaki tusiokuwa wakamilifu, tamaa zetu ni nyingi, na upendo wa faida au starehe yetu binafsi mara nyingi unakuwa kipaumbele chetu cha ubinafsi 😔\n\n🙏 Muombe Mungu hekima, upendo wake, nguvu zake, na ukiri udhaifu wako kwa unyenyekevu, kwa kuwa hatuwezi kumficha chochote... Chochote 🙏\n\n🥖 Funga kama Danieli: jinyime kwa muda unachokipenda zaidi, katika utulivu na hekima 🥖\n\n💫 Hii itakuwezesha kusikia Mungu vizuri zaidi, kuwa na utayari wa moyo tayari kwa mabadiliko makubwa 💫\n\n🌙 Ndipo, ndoto na maono yatakuwa wazi zaidi, kama kwa Yosefu 🌙\n\n⚠️ Jihadhari na kiburi: usiingiwe na 'mimi daima nina haki' au 'najua vizuri' ⚠️\n\n🎁 Kwa kuwa ufunuo wa Mungu ni neema ya ajabu 🎁\n\n💝 Kuwa na imani ni kuingia katika uhusiano na njia ya uhuru wa moyo 💝\n\n🦸‍♂️ Itakufanya mashujaa wenye nguvu, wenye uwezo wa kufanya lisilowezekana 🦸‍♂️\n\n✝️ Kilele cha maarifa, moyo mkweli unasema: 'Nakupa moyo wangu Yesu na nataka kubatizwa' ✝️\n\n🏔️ Umefika kilele cha mlima, shikamana vizuri, vumilia! 🏔️\n\n⬇️ Lazima ushuke na kubeba hazina hii ya thamani: tumaini la uzima wa milele ⬇️\n\n🏆✨ HONGERA! TUNAJIVUNIA WEWE ✨🏆\n🌟 UJASIRI MBEBA WA AMANI WA UJASIRI 🌟\n🕊️✨ MUNGU AKUBARIKI ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
